// Generated by CoffeeScript 2.3.2

import PlayerChooser from './PlayerChooser'
import CardChooser from './CardChooser'

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
;
var ShowDialog,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

ShowDialog = class ShowDialog extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleChangePlayer = this.handleChangePlayer.bind(this);
    this.handleChangeCard = this.handleChangeCard.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.state = {
      playerId: null,
      cardId: null
    };
    return;
  }

  close() {
    this.setState({
      playerId: null,
      cardId: null
    });
    this.props.onClose();
  }

  stateIsOk() {
    return (this.state.playerId != null) && (this.state.cardId != null);
  }

  handleClose() {
    boundMethodCheck(this, ShowDialog);
    this.close();
  }

  handleChangePlayer(playerId) {
    boundMethodCheck(this, ShowDialog);
    this.setState({playerId});
  }

  handleChangeCard(cardId) {
    boundMethodCheck(this, ShowDialog);
    this.setState({cardId});
  }

  handleCancel() {
    boundMethodCheck(this, ShowDialog);
    this.close();
  }

  handleDone() {
    boundMethodCheck(this, ShowDialog);
    if (!this.stateIsOk()) {
      this.props.app.showConfirmDialog("Error", "You must select a player and a card");
      return;
    }
    this.props.app.recordShown(this.state.playerId, this.state.cardId);
    this.close();
  }

  render() {
    var configuration, open, players;
    ({open, players, configuration} = this.props);
    return <Dialog open={open} fullscreen="true" disableBackdropClick={true} onClose={this.handleClose}>
      <DialogTitle id="form-dialog-title">Record A Shown Card</DialogTitle>
      <DialogContent>
        <Typography variant="h4">Who showed the card?</Typography>
        <PlayerChooser value={this.state.playerId} players={players} onChange={this.handleChangePlayer} />
        <Divider />
        <Typography variant="h4">What card did they show?</Typography>
        <CardChooser value={this.state.cardId} cards={configuration.cards} types={configuration.types} onChange={this.handleChangeCard} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={this.handleCancel}>Cancel</Button>
        <Button disabled={!this.stateIsOk()} variant="contained" color="primary" onClick={this.handleDone}>Done</Button>
      </DialogActions>
    </Dialog>;
  }

};

export default ShowDialog;
